<template>
  <div id="app">
    <el-row>
      <!-- <el-col :span="2" style="padding-top: 12px; padding-bottom: 20px; padding-left:10px;" >
        <div class="yourHomeLink"><a href="http://www.16plus1-dzect.org.cn/cn" >17+1</a></div>
        </el-col> -->
      <el-col :span="12">
        <el-menu :default-active="activeIndex" @select="handleSelect" router class="el-menu-demo" mode="horizontal" background-color="#191f29" text-color="#b5bcc7" active-text-color="#16c3c3">
          <el-menu-item index='1'><a href="http://www.e-ceec.org.cn/">17+1</a></el-menu-item>
          <el-menu-item index="Home">首页</el-menu-item>
          <el-menu-item index="ByAmount">贸易量分析</el-menu-item>
          <el-menu-item index="ByGoods">商品分析</el-menu-item>
          <el-menu-item index="ByTradeTerm">贸易方式分析</el-menu-item>
          <el-menu-item index="ByTransport">运输方式分析</el-menu-item>
        </el-menu>
      </el-col>
      <el-col :span="12" style="background-color: #191f29; height:60px;">
        <el-row>
          <el-col :span="16" style="">&nbsp;</el-col>
          <el-col :span="4" style="padding-top:12px;padding-bottom:20px;">
            <div v-if="isShowSelect">
            <el-dropdown @command="onCountrySelectChange" ref="countrySelect">
              <span class="el-dropdown-link">
            中东欧17国<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command=''>全部</el-dropdown-item>
                <el-dropdown-item command='阿尔巴尼亚'>阿尔巴尼亚</el-dropdown-item>
                <el-dropdown-item command='波黑'>波黑</el-dropdown-item>
                <el-dropdown-item command='保加利亚'>保加利亚</el-dropdown-item>
                <el-dropdown-item command='克罗地亚'>克罗地亚</el-dropdown-item>
                <el-dropdown-item command='捷克'>捷克</el-dropdown-item>
                <el-dropdown-item command='爱沙尼亚'>爱沙尼亚</el-dropdown-item>
                <el-dropdown-item command='匈牙利'>匈牙利</el-dropdown-item>
                <el-dropdown-item command='拉脱维亚'>拉脱维亚</el-dropdown-item>
                <el-dropdown-item command='立陶宛'>立陶宛</el-dropdown-item>
                <el-dropdown-item command='北马其顿'>北马其顿</el-dropdown-item>
                <el-dropdown-item command='黑山'>黑山</el-dropdown-item>
                <el-dropdown-item command='波兰'>波兰</el-dropdown-item>
                <el-dropdown-item command='罗马尼亚'>罗马尼亚</el-dropdown-item>
                <el-dropdown-item command='塞尔维亚'>塞尔维亚</el-dropdown-item>
                <el-dropdown-item command='斯洛伐克'>斯洛伐克</el-dropdown-item>
                <el-dropdown-item command='斯洛文尼亚'>斯洛文尼亚</el-dropdown-item>
                <el-dropdown-item command='希腊'>希腊</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            </div>
  
          </el-col>
          <el-col :span="3" style="padding-top:12px;padding-bottom:20px;">
            <div v-if="isShowSelect">
            <el-dropdown @command="onYearSelectChange" ref="yearSelect">
              <span class="el-dropdown-link">
          年度<i class="el-icon-arrow-down el-icon--right"></i>
        </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command=''>全部</el-dropdown-item>
                <el-dropdown-item command='2013'>2013</el-dropdown-item>
                <el-dropdown-item command='2014'>2014</el-dropdown-item>
                <el-dropdown-item command='2015'>2015</el-dropdown-item>
                <el-dropdown-item command='2016'>2016</el-dropdown-item>
                <el-dropdown-item command='2017'>2017</el-dropdown-item>
                <el-dropdown-item command='2018'>2018</el-dropdown-item>
                <el-dropdown-item command='2019'>2019</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            </div>
  
          </el-col>
        </el-row>
  
  
  
        <!-- <div style="background-color: rgb(84, 92, 100); height:60px;">
            <div style="padding:20px;">
         
      </div>
      </div> -->
      </el-col>
  
    </el-row>
    <router-view />
  </div>
</template>

<script>
  export default {
    name: 'App',
    data() {
      return {
        activeIndex: 'Home',
        isShowSelect: false
      }
    },
    computed: {
      myYear() {
        return this.$store.state.myYear
      },
      myCountry() {
        return this.$store.state.myCountry
  
      }
    },
    mounted() {
      let r = this.$route.name;
      this.activeIndex = r;
      if(r == "Home" || r == 'Index') {
        this.isShowSelect = false;
      }
      else
      {
        this.isShowSelect = true;
      }
    },
    methods: {
      handleSelect(key, keyPath) {

        if(key == "Home") {
          this.isShowSelect = false;
        } else {
          this.isShowSelect = true;
        }
        // console.log(key, keyPath);
      },
      onYearSelectChange(selVal) {
        this.$store.commit('changeYear', selVal)
      },
      onCountrySelectChange(selVal) {
        this.$store.commit('changeCountry', selVal)
  
      }
    },
  
    components: {}
  }
</script>

<style>
  
</style>



// WEBPACK FOOTER //
// src/App.vue